import { setupWorker } from 'msw/browser';
import { mswKnitHandler } from '@stitch-fix/knit/msw2';
import { browserGraphHandlers } from './graph';

/**
 * Mocks that interact with the browser
 */
export const worker = setupWorker(mswKnitHandler(), ...browserGraphHandlers);